import { Popover, PopoverContent, PopoverTrigger } from "@ncoder/ui";
import type { Organization } from "@/stores/authStore_v1";

interface OrgBadgeProps {
  org: Organization;
}

export function OrgBadge({ org }: OrgBadgeProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="absolute top-3 left-3 z-20 inline-flex items-center gap-1.5
            h-[30px] px-2.5 rounded-full border border-border bg-card/90 backdrop-blur-sm
            font-mono text-[11px] font-semibold text-foreground cursor-pointer
            transition-[border-color,background] duration-150
            hover:border-foreground/35 hover:bg-muted"
        >
          <span className="max-w-[140px] truncate">{org.orgName ?? "Org"}</span>
          <span className="text-muted-foreground">·</span>
          <span className="text-muted-foreground lowercase">{org.orgType ?? "org"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="start" className="w-64 p-4">
        <div className="grid grid-cols-[max-content_1fr] gap-y-2.5 gap-x-3 font-mono text-[11px]">
          <span className="text-muted-foreground">Name</span>
          <strong className="font-semibold truncate">{org.orgName ?? "—"}</strong>
          <span className="text-muted-foreground">Type</span>
          <strong className="font-semibold truncate">{org.orgType ?? "—"}</strong>
          <span className="text-muted-foreground">Org ID</span>
          <strong className="font-semibold truncate" title={org.id}>{org.id ?? "—"}</strong>
          <span className="text-muted-foreground">Salesforce</span>
          <strong className="font-semibold truncate" title={org.salesforceOrgId ?? ""}>
            {org.salesforceOrgId ?? "—"}
          </strong>
        </div>
      </PopoverContent>
    </Popover>
  );
}
